import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import makeStyles from '@mui/styles/makeStyles';
import Grid from "@mui/material/Grid";

const styles = {
  grid: {
    margin: "0 -15px !important",
    width: "unset",
  }
};

const useStyles = makeStyles(styles);

export default function GridContainer(props) {
  const classes = useStyles();
  const { children, ...rest } = props;
  return (
      <Grid container {...rest} className={classes.grid} ref={props.innerRef}>
      {children}
    </Grid>
  );
}

GridContainer.propTypes = {
    children: PropTypes.node,
    direction: PropTypes.string,
    justify: PropTypes.string,
    alignItems: PropTypes.string,
    spacing: PropTypes.number,
    innerRef: PropTypes.func
};
